import { Collapse } from 'bootstrap'

// Bootstrap's collapse can't be closed from the keyboard, so Esc closes the open mobile menu
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return

  const menu = document.getElementById('navbar-dropdown')
  if (!menu?.classList.contains('show')) return

  Collapse.getOrCreateInstance(menu, { toggle: false }).hide()
  document.querySelector('[data-bs-target="#navbar-dropdown"]').focus()
})
